import React, {useState} from "react";
import {connect} from "react-redux";
import Panel from "../panel/Panel";
import Form from "./forms/Edit";
import {removeAction as removePanelAction} from "../../actions/panel";
import { CrownOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Result, Spin } from "antd";
import EntityLoader from "../common/EntityLoader";

const Title = ({entity}) => <span>
    <CrownOutlined /><UserOutlined /> {!!entity ? `${entity.salutation} ${entity.title} ${entity.firstname} ${entity.lastname}` : '404 - Not Found'}
</span>;

const Content = connect(
    null,
    dispatch => ({
        onRemovePanel: (uniqueKey) => dispatch(removePanelAction(uniqueKey)),
    })
)(({entity, entityId, customerId, onRemovePanel}) => <>
    {entity
        ? <Form customerContactId={entityId} customerId={customerId}/>
        : <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={<Button type="primary" onClick={() => onRemovePanel(`customercontacts:${entityId}:edit`)}>close</Button>}
        />
    }
</>);

export default ({customerContactId, customerId}) => {
    const [loading, setLoading] = useState(true);

    return <Panel
        id={`customercontacts:${customerContactId}:edit`}
        title={
            <EntityLoader entityId={customerContactId}>
                <Title/>
            </EntityLoader>
        }
    >
        <Spin spinning={loading}>
            <EntityLoader entityId={customerContactId} onFinally={() => setLoading(false)}>
                <Content customerId={customerId}/>
            </EntityLoader>
        </Spin>
    </Panel>
}
